import { Component, Input } from '@angular/core';
import { EdicionesI } from 'src/app/interfaces/ambiente.interface';
import { UserI } from 'src/app/interfaces/user.interface';
import { EditionsService } from './editions.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-editions-table',
  templateUrl: './editions-table.component.html',
  styleUrls: ['./editions-table.component.scss'],
})
export class EditionsTableComponent {
  returnData(user: UserI) {

    return user.full_name;
  }

  editions: EdicionesI[] = [];
  @Input() properties!: {
    label: string;
    value: Function;
  }[];

  totalRecords = 0;
  @Input() property!: string;
  @Input() id!: any;

  editedItem: any;

  constructor(private readonly editionService: EditionsService) { }

  ngOnInit() {
    const params = new HttpParams()
      .set('property', this.property)
      .set('id', this.id);

    this.editionService.findAll(params).subscribe((data) => {
      this.editions = data?.result || [];
      this.totalRecords = data.count;
      this.editions.sort(
        (a, b) => new Date(b.fecha!).getTime() - new Date(a.fecha!).getTime()
      );

      this.editions.forEach((i) => {
        try {
          if (i.old_register) i.parseObject = JSON.parse(i.old_register);
          this.comprobarLod(i)

        } catch (error) {
          console.error('Non a json object');
        }
      });
    });
  }
  realizo_lod!: any
  comprobarLod(edition: any) {
    if (edition.editions_form?.id_visible) {
      return this.realizo_lod = true
    } else {
      return this.realizo_lod = false
    }
  }
}
